import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

import './header.scss';

const Header = ({ contacts, logo }) => {
  const [shadow, setShadow] = useState(false);

  const handleScroll = () => {
    setShadow(window.scrollY > 142);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`page-header ${shadow && 'shadow'}`}>
      <div className="container">
        <Link to="/" className="page-header__logo">
          <img src={logo} alt="header logo" />
        </Link>

        <div className="page-header__links">
          <a href={`tel:${contacts?.phone}`} className="btn grey">
            {contacts?.phone}
          </a>

          <NavLink
            to="/book-now"
            className="btn yellow"
            state={{ prevLocation: window.location.pathname.split('/')[1] }}
          >
            Book a Service
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Header;
